import { localize } from 'mixins/helpers';

export const getTaxpayerCodeRule = (
    translations: Record<string, string>,
    required = false
) => ({
    validator: (_rule: any, value?: string) => {
        if (required && !value) {
            return Promise.reject(
                new Error(localize('admin-api-access-validation-required', translations))
            );
        }

        if (!value || /^\d{12}$/.test(value)) {
            return Promise.resolve();
        }

        return Promise.reject(
            new Error(localize('admin-api-access-validation-taxpayer-code', translations))
        );
    },
});